/**
 * "Who & where" (plan 2026-09-27-003, U6): who it went out as, on which
 * channel, into which flow. Every value comes from Clay's answer or Terra's
 * own row — a value Terra does not have is left out, never filled in.
 */
import { Chip } from '@clay-run/glaze/chip';
import { Text } from '@clay-run/glaze/text';

import { readClayRunResultData } from '../../../../_shared/clay-run-status-schema';
import type { RepStatusView } from '../../../dispatch-rep-status';
import type { PlaybooksDispatchLogRow, PlaybooksSentCopyResponse } from '../../../schemas';

import { DetailPanel } from './DetailPanel';

export function WhoWherePanel({
  row,
  view,
  sentCopy,
}: {
  row: PlaybooksDispatchLogRow;
  view: RepStatusView;
  sentCopy: PlaybooksSentCopyResponse | null;
}) {
  const sender = sentCopy?.sender ?? readClayRunResultData(row.result_data)?.clay_sender?.sender_email ?? row.sender_email;
  const flowTag = sentCopy?.flowTag ?? null;
  return (
    <DetailPanel title="Who & where">
      <dl className="grid grid-cols-[78px_minmax(0,1fr)] gap-y-1.5 text-xs">
        {sender !== null && (
          <>
            <dt className="text-content-tertiary">Sender</dt>
            <dd className="break-words text-content-primary">{sender}</dd>
          </>
        )}
        {view.channelLabel !== null && (
          <>
            <dt className="text-content-tertiary">Channel</dt>
            <dd className="text-content-primary">{view.channelLabel}</dd>
          </>
        )}
        {flowTag !== null && (
          <>
            <dt className="text-content-tertiary">Flow</dt>
            <dd>
              <Chip size="xs" color="purple">
                {flowTag}
              </Chip>
            </dd>
          </>
        )}
        {row.contact_email !== null && (
          <>
            <dt className="text-content-tertiary">Email</dt>
            <dd className="break-words text-content-primary">{row.contact_email}</dd>
          </>
        )}
      </dl>
      {sender === null && view.channelLabel === null && flowTag === null && row.contact_email === null && (
        <Text size="xs" variant="tertiary">
          Nothing recorded yet.
        </Text>
      )}
    </DetailPanel>
  );
}
